import gql from "graphql-tag";

export const ActivityInfoFragment = gql`
  fragment ActivityInfo on Activity {
    _id
    activity_date
    activity_trigger_action
    activity_trigger_action_data
    activity_source_UID
    activity_trigger_action_data_reason
    activity_trigger_source
    activity_source_context
    activity_trigger_by_user_id
    activity_updated_by {
      _id
      first_name
      last_name
      email
      phone_number
    }
  }
`;
export const LocationInfoFragment = gql`
  fragment LocationInfo on Location {
    latitude
    longitude
  }
`;

export const AddressInfoFragment = gql`
  fragment AddressInfo on Address {
    country
    city
    region
    address
    additional_address
    location {
      ...LocationInfo
    }
    place_id
  }
  ${LocationInfoFragment}
`;
export const AddressInfoClientFragment = gql`
  fragment AddressInfoClient on Address {
    country
    city
    region
    address
    place_id
  }
`;
export const ReceiverInfoFragment = gql`
  fragment ReceiverInfo on Receiver {
    receiver_lastname
    receiver_firstname
    receiver_phone_number
    receiver_specification_address
    receiver_entreprise
    _id
    receiver_created_at
    receiver_last_edited_at
    receiver_address {
      ...AddressInfo
    }
  }
  ${AddressInfoFragment}
`;
export const ClientInfoFragment = gql`
  fragment ClientInfo on Client {
    client_company_name
    client_phone_number
    client_contact_firstname
    client_contact_lastname
    client_default_address {
      phone_number
    }
    client_address {
      ...AddressInfoClient
    }
  }
  ${AddressInfoClientFragment}
`;
export const ParcelInfoFragment = gql`
  fragment ParcelInfo on Parcel {
    _id
    parcel_UID
    parcel_description
    parcel_size
    parcel_value
    parcel_amount_to_collect
    parcel_client_reference
    parcel_status
    parcel_return
    parcel_return_raison
    parcel_created_at
    parcel_last_edited_at
    parcel_delivery_date
    parcel_delivery_slot_start
    parcel_delivery_slot_end
    parcel_user_UID
    parcel_attempts
    parcel_additional_info
    isOutOfStock
    comment
    reason_UID
    parcel_reason {
      reason_name
    }
    parcel_attempts_real
    parcel_order {
      _id
      order_UID
      order_status
      order_date
      order_time
      order_receiver {
        ...ReceiverInfo
      }
      order_client {
        ...ClientInfo
      }
      order_validation_signature
      deliveryAddress {
        address
      }
    }
    parcel_activities {
      ...ActivityInfo
    }
    parcel_created_by {
      source
    }
  }
  ${ReceiverInfoFragment}
  ${ActivityInfoFragment}
  ${ClientInfoFragment}
`;
export const ParcelSimpleInfoFragment = gql`
  fragment ParcelSimpleInfo on Parcel {
    _id
    parcel_UID
    parcel_description
    parcel_size
    parcel_value
    parcel_amount_to_collect
    parcel_client_reference
    parcel_additional_info
    parcel_status
    parcel_return
    parcel_return_raison
    parcel_created_at
    parcel_last_edited_at
    parcel_delivery_date
    parcel_user_UID
    parcel_attempts
    reason_UID
    parcel_client {
      _id
      client_company_name
      client_phone_number
      client_contact_firstname
      client_contact_lastname
      __typename
      client_address {
        country
        city
        region
        address
        place_id
      }
    }
    pickupAddress {
      address
    }
    pickupMoreInfo {
      firstName
      lastName
      phoneNumber
    }
    relay {
      name
      types
      location {
        address
      }
    }
  }
`;
// todo
export const OrderInfoFragment = gql`
  fragment OrderInfo on Order {
    _id
    order_UID
    order_status
    order_date
    order_time
    order_created_at
    order_receiver {
      ...ReceiverInfo
    }
    order_client {
      ...ClientInfo
    }
    order_parcels {
      ...ParcelSimpleInfo
    }
    relay {
      name
      types
      location {
        address
      }
    }

    order_activities {
      ...ActivityInfo
    }
  }
  ${ReceiverInfoFragment}
  ${ParcelSimpleInfoFragment}
  ${ActivityInfoFragment}
  ${ClientInfoFragment}
`;
export const AdressFragment = gql`
  fragment AdressFragment on Address {
    country
    city
    region
    address
    additional_address
    location {
      latitude
      longitude
    }
    place_id
  }
`;
export const SimpleOrderInfoFragment = gql`
  fragment SimpleOrderInfo on Order {
    _id
    order_UID
    order_status
    order_date
    order_time
    order_created_at
    order_created_by {
      source
    }
    order_job {
      job_type
    }
    order_receiver {
      ...ReceiverInfo
    }
    relay {
      _id
      name
      location {
        _id
        city
      }
    }
    order_parcels {
      _id
    }
  }
  ${ReceiverInfoFragment}
`;

export const JobInfoFragment = gql`
  fragment JobInfo on Job {
    _id
    job_UID
    job_type
    job_address {
      ...AddressInfo
    }
    job_date
    job_time
    job_status
    job_vehicle_type
    job_created_at
    job_last_edited_at
    job_orders {
      ...OrderInfo
    }
    job_client {
      _id
      client_address {
        ...AddressInfo
      }
    }
  }
  ${OrderInfoFragment}
  ${AddressInfoFragment}
`;

export const TaskHistoryFragment = gql`
  fragment TaskHistoryFragment on TaskClientHistoryExport {
    task_UID
    task_type
    task_status
    creationDate
    receiver_fullname
    receiver_phone_number
    city
    address
    execution_date
    completionDate
    parcels
    creation_date
    updated_date
  }
`;

export const ParcelExportFragment = gql`
  fragment ParcelExportFragment on ParcelsExport {
    parcel_UID
    receiver_fullname
    receiver_phone_number
    creation_date
    delivery_date
    status
    amount_to_collect
    attemps
    size
    creation_date
    updated_date
    firstName
    lastName
    phoneNumber
    address {
      address
    }
    service
    reference
    isDeleted
  }
`;

export const AllHubFragment = gql`
  fragment AllHubFragment on Hub {
    _id
    name
    code
    types
    openHour
    endHour
    email
    phoneNumber
    users {
      _id
      first_name
      last_name
      email
      phone_number
      roles {
        name
      }
    }
    location {
      country
      countryCode
      city
      region
      place_id
      address
      additional_address
    }
    country {
      _id
      name
      code
    }
  }
`;
